module.exports = __webpack_public_path__ + "static/media/bannerHistory.2a1f4d0a.jpg";